import { queryOptions, useQuery } from '@tanstack/react-query'

import { fetchDashboardTips } from '../../../dal/contentful-dashboard-dal'
import { useContentfulLocale } from '../../../hooks/useContentfulLocale'
import { resolveDailyTip } from '../../../queries/dashboard-queries'
import { queryKeys } from '../../../queries/query-keys'

export function useDashboardDailyTip() {
  const language = useContentfulLocale()
  const { data: tips } = useQuery(
    queryOptions({
      queryKey: queryKeys.dashboard.tips.byLocale(language),
      queryFn: () => fetchDashboardTips(language),
    }),
  )
  const todaysTip = resolveDailyTip({ tips: tips ?? [], date: new Date() })
  const showTipToggle = Boolean(todaysTip?.tip?.trim())

  return {
    todaysTip,
    showTipToggle,
  }
}
